import { useAppSelector } from "@/hooks";
import Sentry from "@/lib/sentry";
import { jwtDecode } from "jwt-decode";
import { usePostHog } from "posthog-js/react";
import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface AuthGuardProps {
  children: React.ReactNode;
}

function AuthGuard({ children }: Readonly<AuthGuardProps>) {
  const posthog = usePostHog();
  const isLogged = useAppSelector((state) => state.login.isConnected);
  const token = useAppSelector((state) => state.login.userToken);
  const { pathname } = useLocation();

  useEffect(() => {
    if (token) {
      const jwt = jwtDecode(token.accessToken);
      Sentry.setUser({ id: jwt?.sub });
      posthog.identify(jwt?.sub as string);
    }
  }, [token]);

  if (!isLogged) {
    return <Navigate to={`/login?redirectTo=${pathname}`} />;
  }

  return children;
}

export default AuthGuard;
